import { Injectable } from '@angular/core';
import { KYMW7005Model } from '../kymw7005.model';
import { FeatureGoods } from '../vo/feature-goods.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
interface GetFeatureGoodsListResponse {
  TotalNum: string,
  StartDispNum: string,
  EndDispNum: string,
  FeatureGoodsList: {
      OrderCode: string,
      MediumType: string,
      FeatureCode: string,
      FeatureName: string,
      BuyerNotice: string,
      SupplierCode: string,
      SupplierName: string,
      PCode: string,
      GuideGoodsName: string,
      JanCode: string,
      ItemCode: string,
      GuideStandardName: string,
      MakerName: string,
      SupplyPriceStandard: string,
      SupplyPrice: string,
      CostPriceStandard: string,
      CostPrice: string,
      StockNum: string,
      OrderUnitType: string,
      NewUnitType: string,
      PricePattern: string,
      Remarks: string,
      ReplacementStatus: string,
      SelectorType: number,
   }[];
}

@Injectable({
  providedIn: 'root'
})
export class GetFeatureGoodsService extends PlessJsonResponderSub<GetFeatureGoodsListResponse> {

  model: KYMW7005Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureRequestListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetFeatureGoods: {
          condition: {
            OrderCode: this.model.queryParams.orderCode,
            MediumType: this.model.queryParams.mediumType,
            Page: this.model.pageNo,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureRequestListService
   */
  execute(model: KYMW7005Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('getFeatureGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureRequestListService
   */
  success(data: GetFeatureGoodsListResponse) {
    this.model.totalNum = Number(data.TotalNum);
    this.model.startDispNum = Number(data.StartDispNum);
    this.model.endDispNum = Number(data.EndDispNum);
    this.model.featureGoods = data.FeatureGoodsList.map(_ => 
      new FeatureGoods(
        _.OrderCode,
        _.MediumType,
        _.FeatureCode,
        _.FeatureName,
        _.BuyerNotice,
        _.SupplierCode,
        _.SupplierName,
        _.PCode,
        _.GuideGoodsName,
        _.JanCode,
        _.ItemCode,
        _.GuideStandardName,
        _.MakerName,
        PlessViewUtilsSub.isEmpty(_.SupplyPriceStandard) ? '' : Number(_.SupplyPriceStandard),
        PlessViewUtilsSub.isEmpty(_.SupplyPrice) ? '' : Number(_.SupplyPrice),
        PlessViewUtilsSub.isEmpty(_.CostPriceStandard) ? '' : Number(_.CostPriceStandard),
        PlessViewUtilsSub.isEmpty(_.CostPrice) ? '' : Number(_.CostPrice),
        PlessViewUtilsSub.isEmpty(_.StockNum) ? '' : Number(_.StockNum),
        _.OrderUnitType,
        _.NewUnitType,
        _.PricePattern,
        _.Remarks,
        _.ReplacementStatus,
        _.SelectorType,
      )
    );

    this.model.featureGoodsEdit = data.FeatureGoodsList.map(_ => 
      new FeatureGoods(
        _.OrderCode,
        _.MediumType,
        _.FeatureCode,
        _.FeatureName,
        _.BuyerNotice,
        _.SupplierCode,
        _.SupplierName,
        _.PCode,
        _.GuideGoodsName,
        _.JanCode,
        _.ItemCode,
        _.GuideStandardName,
        _.MakerName,
        PlessViewUtilsSub.isEmpty(_.SupplyPriceStandard) ? '' : Number(_.SupplyPriceStandard),
        PlessViewUtilsSub.isEmpty(_.SupplyPrice) ? '' : Number(_.SupplyPrice),
        PlessViewUtilsSub.isEmpty(_.CostPriceStandard) ? '' : Number(_.CostPriceStandard),
        PlessViewUtilsSub.isEmpty(_.CostPrice) ? '' : Number(_.CostPrice),
        PlessViewUtilsSub.isEmpty(_.StockNum) ? '' : Number(_.StockNum),
        _.OrderUnitType,
        _.NewUnitType,
        _.PricePattern,
        _.Remarks,
        _.ReplacementStatus,
        _.SelectorType,
      )
    );

    if (this.calbak) this.calbak();
  }
}